import { useState } from 'react';
import type { FormEvent } from 'react';
import { api, ApiError } from '../lib/api';

export default function MissionaryCreatePage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [saving, setSaving] = useState(false);
  const [feedback, setFeedback] = useState<{ kind: 'error' | 'success'; text: string } | null>(null);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setSaving(true);
    setFeedback(null);
    try {
      const res = await api.post<{ message: string; promoted?: boolean }>('/admin/create-missionary', {
        name: name.trim(),
        email: email.trim(),
        password: password || 'Misionero2024!',
      });
      const successText = res?.promoted
        ? `"${name}" ya tenía cuenta: ahora es misionero (su contraseña no se ha modificado)`
        : `Misionero "${name}" creado correctamente`;
      setFeedback({ kind: 'success', text: successText });
      setName(''); setEmail(''); setPassword('');
    } catch (err) {
      setFeedback({ kind: 'error', text: err instanceof ApiError ? err.message : 'No se pudo crear el misionero' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <h1 className="page-title">Crear Misionero Digital</h1>
      {feedback && (
        <div className={'alert ' + (feedback.kind === 'error' ? 'alert-error' : 'alert-success')}>
          {feedback.text}
        </div>
      )}
      <form className="card" onSubmit={onSubmit}>
        <div className="field">
          <label>Nombre *</label>
          <input required value={name} onChange={e => setName(e.target.value)} />
        </div>
        <div className="field">
          <label>Email *</label>
          <input required type="email" value={email} onChange={e => setEmail(e.target.value)} />
        </div>
        <div className="field">
          <label>Contraseña</label>
          <input type="text" value={password} onChange={e => setPassword(e.target.value)} placeholder="Misionero2024! (por defecto)" />
          <small className="muted">Si lo dejas vacío se usará la contraseña por defecto. Si el email ya existe en la app, se mantendrá su contraseña actual.</small>
        </div>
        <button type="submit" className="btn" disabled={saving}>
          {saving ? 'Creando…' : 'Crear misionero'}
        </button>
      </form>
    </>
  );
}
